export default __webpack_public_path__ + "static/media/SlackLogo.0c70ae08.png";